export const articlesSearchPanelMixin = {
  props: {
    articles: {
      type: Array,
      default: () => []
    },
    loadingData: {
      type: Boolean,
      default: false
    },
    currentArticleTitle: {
      type: String,
      default: ''
    },
    minHeight: {
      type: Number,
      default: 50
    },
    initialSearchText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      items: []
    }
  },
  created() {
    this.fetchItemsHandler()
  },
  methods: {
    goToPage(page) {
      this.$emit('gotopage', page)
    },
    clearItemsHandler() {
      this.items = []
    }
  }
}
